//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles } from '@material-ui/core';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { nl2br } from '../../common/textHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    const { bio, benefit } = params;
    return makeStyles(theme => ({
        root: {
            width: '100%',
            backgroundColor: 'white',
            borderRadius: '10px',
            marginRight: '24px',
            padding: '40px',
            [theme.breakpoints.down('lg')]: { padding: 30 },
            [theme.breakpoints.down('md')]: { padding: 24 },
            [theme.breakpoints.down('sm')]: { marginTop: 16, marginRight: '0px' },
        },
        label: {
            fontSize: '16px',
            fontWeight: 'bold',
            lineHeight: '19px',
        },
        propsText: {
            fontSize: '15px',
            fontWeight: 'normal',
            lineHeight: '26px',
            color: 'black',
        },
        bioContainer: { marginBottom: 48, display: bio ? 'block' : 'none' },
        benefitContainer: { marginBottom: 48, display: benefit ? 'block' : 'none' },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        // props,
        classes,
    } = params;

    const defns = {};

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const CompanyBioBenefit = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { companyInfoData } = props;
    const bio = _get(companyInfoData, 'bio');
    const benefit = _get(companyInfoData, 'benefit');

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const classes = useStyles({ bio, benefit })();
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <div {...defns.bioContainer}>
                <h3 {...defns.label}>Company Bio</h3>
                <p {...defns.propsText}>{nl2br(bio)}</p>
            </div>
            <div {...defns.benefitContainer}>
                <h3 {...defns.label}>Benefits Summary</h3>
                <p {...defns.propsText}>{nl2br(benefit)}</p>
            </div>{' '}
        </div>
    );
};

export default CompanyBioBenefit;
